'use client';

import { c as _c } from "react/compiler-runtime";
import { Body, Button, H5, InputOTP, InputOTPGroup, InputOTPSlot } from '@material-bank/mb3-components';
import { ArrowLeftIcon, RefreshCw } from '@material-bank/mtag-icons';
import { useTranslations } from '@material-bank/i18n';
import { MbLogoLink } from '../MbLogoLink/MbLogoLink';
import { useOtpStep } from '../../hooks/useOtpStep';
type OtpStepProps = {
  email: string;
  isLoading: boolean;
  error: string | null;
  onSubmit: (otp: string) => void;
  onResend: () => void;
  onBack: () => void;
};
export function OtpStep(t0) {
  const $ = _c(53);
  const {
    email,
    isLoading,
    error,
    onSubmit,
    onResend,
    onBack
  } = t0;
  const t = useTranslations("authentication.otpStep");
  let t1;
  if ($[0] !== error || $[1] !== onResend || $[2] !== onSubmit) {
    t1 = {
      onSubmit,
      onResend,
      error
    };
    $[0] = error;
    $[1] = onResend;
    $[2] = onSubmit;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    otp,
    setOtp,
    countdown,
    completeHandler,
    resendHandler,
    keyDownHandler,
    inputRef
  } = useOtpStep(t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MbLogoLink />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("heading");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <H5 weight="semibold">{t3}</H5>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== email || $[10] !== t) {
    t5 = t.rich("subheading", {
      email,
      em: _temp
    });
    $[9] = email;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <Body className="text-muted-foreground" weight="regular">{t5}</Body>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("spamFolder");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <Body className="text-muted-foreground" weight="regular">{t7}</Body>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="flex flex-col">{t6}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [...Array(6)].map(_temp2);
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== completeHandler || $[23] !== inputRef || $[24] !== isLoading || $[25] !== keyDownHandler || $[26] !== otp || $[27] !== setOtp) {
    t11 = <InputOTP ref={inputRef} maxLength={6} value={otp} disabled={isLoading} autoFocus={true} autoComplete="one-time-code" onChange={setOtp} onComplete={completeHandler} onKeyDown={keyDownHandler}>{t10}</InputOTP>;
    $[22] = completeHandler;
    $[23] = inputRef;
    $[24] = isLoading;
    $[25] = keyDownHandler;
    $[26] = otp;
    $[27] = setOtp;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== error) {
    t12 = error ? <Body variant="small" className="text-red-600">{error}</Body> : null;
    $[29] = error;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== countdown || $[32] !== isLoading || $[33] !== resendHandler || $[34] !== t) {
    t13 = countdown > 0 ? <Body variant="small" className="text-muted-foreground" weight="regular">{t("resendCountdown", {
        countdown
      })}</Body> : <Button variant="ghost" type="button" disabled={isLoading} className="w-fit text-muted-foreground" onClick={resendHandler}><RefreshCw />{t("resendButton")}</Button>;
    $[31] = countdown;
    $[32] = isLoading;
    $[33] = resendHandler;
    $[34] = t;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t11 || $[37] !== t12 || $[38] !== t13) {
    t14 = <div className="flex flex-col gap-4">{t11}{t12}{t13}</div>;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ArrowLeftIcon />;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t) {
    t16 = t("back");
    $[41] = t;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== onBack || $[44] !== t16) {
    t17 = <Button variant="ghost" type="button" className="w-fit pl-0 mt-auto" onClick={onBack}>{t15}{t16}</Button>;
    $[43] = onBack;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t14 || $[47] !== t17 || $[48] !== t9) {
    t18 = <div className="flex flex-col gap-8 flex-1">{t9}{t14}{t17}</div>;
    $[46] = t14;
    $[47] = t17;
    $[48] = t9;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== t18 || $[51] !== t4) {
    t19 = <div className="flex flex-col gap-[48px] h-full">{t2}<div className="flex flex-col gap-3 flex-1">{t4}{t18}</div></div>;
    $[50] = t18;
    $[51] = t4;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  return t19;
}
function _temp2(_, i) {
  return <InputOTPGroup key={i}><InputOTPSlot index={i} /></InputOTPGroup>;
}
function _temp(chunks) {
  return <span className="text-foreground">{chunks}</span>;
}